var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
            ]),
            _c(
              "el-breadcrumb-item",
              { attrs: { to: { path: "/fix_order" } } },
              [_c("div", { staticClass: "div3" }, [_vm._v("改单记录")])]
            ),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("订单详情")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "state" }, [
      !_vm.is_null(_vm.detailC.orderUser)
        ? _c("p", { staticClass: "header" }, [
            _vm._v(
              " 订单状态：" + _vm._s(_vm.detailC.orderUser.orderType) + " "
            ),
          ])
        : _vm._e(),
      _c("ul", [
        _c("li", [
          !_vm.is_null(_vm.detailC.orderUser)
            ? _c("p", [
                _vm._v(
                  " 订单编号：" + _vm._s(_vm.detailC.orderUser.orderIdStr) + " "
                ),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.detailC.orderUser)
            ? _c("p", [
                _vm._v(
                  " 下单时间：" +
                    _vm._s(_vm.detailC.orderUser.createdTime) +
                    " "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "address" }, [
      _c("p", { staticClass: "header" }, [_vm._v("收货人信息")]),
      _c("ul", [
        _c("li", [
          !_vm.is_null(_vm.detailC.orderUser)
            ? _c("p", [
                _vm._v(
                  " 收货人姓名：" +
                    _vm._s(_vm.detailC.orderUser.addressName) +
                    " "
                ),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.detailC.orderUser)
            ? _c("p", [
                _vm._v(
                  " 联系电话：" +
                    _vm._s(_vm.detailC.orderUser.addressPhone) +
                    " "
                ),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.detailC.orderUser)
            ? _c("p", [
                _vm._v(
                  " 收货地址：" + _vm._s(_vm.detailC.orderUser.address) + " "
                ),
              ])
            : _vm._e(),
        ]),
        _c("li", [
          _vm.detailC.orderUser && _vm.detailC.orderUser.comment
            ? _c("p", [
                _vm._v(" 备注：" + _vm._s(_vm.detailC.orderUser.comment) + " "),
              ])
            : _c("p", [_vm._v("备注：无")]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "orderBox" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("订单商品")]),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.detailC.orderCommodityList },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "number", label: "商品数量" },
            }),
            _c("el-table-column", {
              attrs: { prop: "price", label: "商品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "brandName", label: "商品品牌" },
            }),
            _c("el-table-column", {
              attrs: { prop: "typeName", label: "商品分类" },
            }),
            _c("el-table-column", {
              attrs: { prop: "specificationName", label: "商品规格" },
            }),
            _c("el-table-column", {
              attrs: { prop: "total", label: "商品小计" },
            }),
            _c("el-table-column", {
              attrs: { prop: "updatedTime", label: "更新时间" },
            }),
          ],
          1
        ),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.detailC.orderComplimentaryList },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "complimentaryName", label: "赠品名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "number", label: "赠品数量" },
            }),
            _c("el-table-column", {
              attrs: { prop: "price", label: "赠品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "brandName", label: "商品品牌" },
            }),
            _c("el-table-column", {
              attrs: { prop: "typeName", label: "赠品分类" },
            }),
            _c("el-table-column", {
              attrs: { prop: "specificationName", label: "赠品规格" },
            }),
            _c("el-table-column", {
              attrs: { prop: "total", label: "赠品小计" },
            }),
            _c("el-table-column", {
              attrs: { prop: "updatedTime", label: "更新时间" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "total" }, [
      !_vm.is_null(_vm.detailC.orderUser)
        ? _c("p", [
            _vm._v(
              " 总计：共 " + _vm._s(_vm.detailC.orderUser.pieceNumber) + " 件 "
            ),
          ])
        : _vm._e(),
      !_vm.is_null(_vm.detailC.orderUser)
        ? _c("p", [
            _vm._v(" 总价：" + _vm._s(_vm.detailC.orderUser.total) + " "),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "fix" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "最近改单记录", name: "first" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "address",
                    staticStyle: { margin: "0", padding: "0" },
                  },
                  [
                    _c("p", { staticClass: "header" }, [
                      _vm._v("改单前收货地址"),
                    ]),
                    _c("ul", [
                      _c("li", [
                        !_vm.is_null(
                          _vm.tableData.userChangeBefore.orderUserChange
                        )
                          ? _c("p", [
                              _vm._v(
                                " 收货人姓名：" +
                                  _vm._s(
                                    _vm.tableData.userChangeBefore
                                      .orderUserChange.addressName
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        !_vm.is_null(
                          _vm.tableData.userChangeBefore.orderUserChange
                        )
                          ? _c("p", [
                              _vm._v(
                                " 联系电话：" +
                                  _vm._s(
                                    _vm.tableData.userChangeBefore
                                      .orderUserChange.addressPhone
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        !_vm.is_null(
                          _vm.tableData.userChangeBefore.orderUserChange
                        )
                          ? _c("p", [
                              _vm._v(
                                " 收货地址：" +
                                  _vm._s(
                                    _vm.tableData.userChangeBefore
                                      .orderUserChange.address
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("li"),
                    ]),
                  ]
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData.userChangeBefore.commodityChangeList,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "商品名称" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "number", label: "商品数量" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "price", label: "商品单价" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "specificationName", label: "商品规格" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "total", label: "商品小计" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "updatedTime", label: "更新时间" },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData.userChangeBefore
                        .complimentaryChangeList,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "complimentaryName", label: "赠品名称" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "number", label: "赠品数量" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "price", label: "赠品单价" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "specificationName", label: "赠品规格" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "total", label: "赠品小计" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "updatedTime", label: "更新时间" },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "total" }, [
                  !_vm.is_null(_vm.tableData.userChangeBefore)
                    ? _c("p", [
                        _vm._v(
                          " 总计：共 " +
                            _vm._s(
                              _vm.tableData.userChangeBefore.orderUserChange
                                .pieceNumber
                            ) +
                            " 件 "
                        ),
                      ])
                    : _vm._e(),
                  !_vm.is_null(_vm.tableData.userChangeBefore)
                    ? _c("p", [
                        _vm._v(
                          " 总价：" +
                            _vm._s(
                              _vm.tableData.userChangeBefore.orderUserChange
                                .total
                            ) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "所有改单记录", name: "all" } },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.changeAllOrder.length,
                        expression: "changeAllOrder.length",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.changeAllOrder },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "expand" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "el-form",
                                { staticClass: "demo-table-expand" },
                                [
                                  _c(
                                    "el-form-item",
                                    _vm._l(
                                      props.row.commodityChangeList,
                                      function (items) {
                                        return _c("p", { key: items.id }, [
                                          _c("span", [
                                            _vm._v(_vm._s(items.name)),
                                          ]),
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(items.price) +
                                                " × " +
                                                _vm._s(items.number) +
                                                " = " +
                                                _vm._s(items.total) +
                                                " 元"
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                  props.row.complimentaryChangeList
                                    ? _c(
                                        "el-form-item",
                                        [
                                          _c(
                                            "span",
                                            { staticStyle: { color: "red" } },
                                            [_vm._v("附属品：")]
                                          ),
                                          _vm._l(
                                            props.row.complimentaryChangeList,
                                            function (items) {
                                              return _c(
                                                "p",
                                                {
                                                  key: items.id,
                                                  staticClass: "complimentary",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        items.complimentaryName
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(items.price) +
                                                        " × " +
                                                        _vm._s(items.number) +
                                                        " = " +
                                                        _vm._s(items.total) +
                                                        " 元"
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderUserChange.orderIdStr",
                        label: "订单编号",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderUserChange.address",
                        label: "改单后收货地址",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderUserChange.addressName",
                        label: "客户",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderUserChange.addressPhone",
                        label: "手机号码",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderUserChange.updatedTime",
                        label: "修改时间",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("p", { staticStyle: { height: "30px" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }